import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const fetchSeverityTypeSchema = (customer, severityType) => {
  return axios({
    url: `/rule/${customer}/new/${severityType}`,
    method: 'get'
  });
};

const useGetSeverityTypeSchema = (customer, severityType) => {
  return useQuery(
    ['severity_rule_schema', customer, severityType],
    () => fetchSeverityTypeSchema(customer, severityType),
    {
      enabled: !!customer && !!severityType
    }
  );
};

export default useGetSeverityTypeSchema;
